<template>
  <div class="page">
    <!--    <div style="padding: 30px;background-color: #ffffff;display: flex;justify-content: center">-->
    <!--      <el-button style="padding: 15px" type="primary" @click="goAll">一键全部打印</el-button>-->
    <!--    </div>-->
    <div style="padding: 30px;background-color: #ffffff;">
      <el-table :data="orderList.currentPageData" border style="width: 100%">
        <!--    <el-table-column  align="center"  type="selection"  :reserve-selection="true"/>-->
        <el-table-column align="center" label="序号" prop="id"/>
        <el-table-column align="center" label="订单号" prop="order_num" width="180">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; color: #409eff;text-align: center;">
              <a style="display: block;text-align: center;">{{ scope.row.order_num }}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="打印次数" prop="print_num"/>
        <el-table-column align="center" label="是否所有子订单成本价已填写" prop="created_at">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.is_cost) === 1 ? '是' : '否' }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单状态" prop="status_name" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="danger">{{ scope.row.status_name }}</el-tag>
            <el-tag v-else-if="scope.row.status == 2" style="color: #ffa408" type="warning">{{
                scope.row.status_name
              }}
            </el-tag>
            <el-tag v-else-if="scope.row.status == 4" type="success">{{ scope.row.status_name }}</el-tag>
            <el-tag v-else-if="scope.row.status == 5" type="warning">{{ scope.row.status_name }}</el-tag>
            <el-tag v-else-if="scope.row.status == 6" type="info">{{ scope.row.status_name }}</el-tag>
            <el-tag v-else-if="scope.row.status == 7" type="success">{{ scope.row.status_name }}</el-tag>
            <el-tag v-else type="primary">{{ scope.row.status_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="下单用户" prop="user_info.nickname"/>
        <el-table-column align="center" label="用户ID" prop="user_info.user_id"/>
        <el-table-column align="center" label="用户头像" prop="photo_url">
          <template slot-scope="scope">
            <img :src="scope.row.user_info.photo_url" style="width: 36px; border-radius: 50%"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="实付" prop="pay_amount" width="120">
          <template slot-scope="scope">
            <span>￥{{ scope.row.pay_amount }}</span>
            <el-tooltip v-if="scope.row.status == 1 && scope.row.pay_way == 'balance'" class="item" content="修改订单金额"
                        effect="dark" placement="top-start">
              <span style="margin-left: 10px; cursor: pointer" @click="openEditPayAmountDialog(scope.row)">
                <i class="el-icon-edit"></i>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="支付方式" prop="pay_way">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_way == 'weixin' ">微信支付</span>
            <span v-if="scope.row.pay_way == 'wechatpay'">微信支付</span>
            <span v-if="scope.row.pay_way == 'free'">-</span>
            <span v-if="scope.row.pay_way == 'balance'">余额支付</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" prop="created_at" width="200"/>
        <el-table-column align="center" label="支付时间" prop="pay_time" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.pay_time == null">未支付</div>
            <div v-else>{{ scope.row.pay_time }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收货人" prop="address_info.consignee"/>
        <el-table-column align="center" label="收货人手机号" prop="address_info.phone" width="120"/>
        <el-table-column align="center" label="收货人地址" prop="address_info.province" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.address_info.province != ''"> {{
                scope.row.address_info.province
              }}/{{ scope.row.address_info.city }}/{{ scope.row.address_info.area }}/{{
                scope.row.address_info.address
              }}
            </div>
            <div v-else>地址未填写</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发货时间" prop="address_info.express_time" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.express_time != null">
              {{ scope.row.express_time }}
            </div>
            <div v-else>尚未发货</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="已退金额" prop="refund_amount">
          <template slot-scope="scope">
            <span>{{ scope.row.refund_amount == 0 ? "无" : scope.row.refund_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="go(scope.row.id)">打印出仓单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :background="true"
          :current-page="orderList.page"
          :page-size="orderList.limit"
          :total="orderList.total"
          layout="prev, pager, next, jumper"
          @current-change="pageChange"
        ></el-pagination>
      </div>

    </div>
    <el-dialog :append-to-body="true" :visible.sync="stopShow">
      <div>
        <div style="text-align: center">正在打印</div>
        <div v-loading="loading"
             style="display: flex;justify-content: center;height: 100px"></div>
        <div style="display: flex;justify-content: center">
          <el-button style="padding: 15px" type="primary" @click="stop">停止打印</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
const {ipcRenderer} = window.require('electron')
import {mapState} from 'vuex';
// import {ipcRenderer} from 'electron'
// import { ipcMain } from "electron";
import {DOMAIN_URL} from '@/config/config';
import {Paging} from "@/utils/paging";

export default {
  computed: {
    // ...mapGetters(['paintStatus']),
    ...mapState({
      paintStatus: state => state.app.paintStatus
    })
  },
  data() {
    return {
      printList: [],
      printerName: '',
      webShow: false,
      webSrc: '',
      NumShow: false,
      amount: '',
      amountList: [],
      url: '#',
      loading: true,
      stopShow: false,
      stopFlag: false,
      isShow: true,
      whenDay: 'today',
      orderList: new Paging(this.$api.getOrderListUrl, 1, 10),
      patinShow: false,
      timerId: null,
      DOMAIN_URL
    }
  },
  mounted() {
    this.getOrderList()
    ipcRenderer.send('getPrinterList')
    // 监听主线程获取到打印机列表后的回调
    ipcRenderer.once('getPrinterList', (event, data) => {
      //data就是打印机列表
      console.log(data, event, '打印的列表')
      // this.printList = data;
      for (var i = 0; i < data.length; i++) {
        this.printList.push(data[i])
        // 设置默认打印机
        if (data[i].isDefault) {
          this.printerName = data[i].name
        }
        console.log(this.printerName, '名称')
      }
    });
    //当上一次打印完成后，执行这里，根据多次打印的业务处理逻辑
    ipcRenderer.on('print-reply', (event, arg, show_id, fileType) => {
      this.getOrderList()
    })
    ipcRenderer.on('print-error', (event, arg, show_id, fileType) => {
      this.getOrderList()
    })
  },
  created() {

  },
  beforeDestroy() {
    //页面销毁时，需要移除监听
    ipcRenderer.removeAllListeners('print-reply')
    ipcRenderer.removeAllListeners('print-error')
  },
  methods: {

    stop() {
      this.stopFlag = true
      this.stopShow = false
    },
    go(id) {
      this.stopShow = true
      let token = localStorage.getItem('user_token')
      console.log(this.printerName, '名称')
      let url = `${this.DOMAIN_URL}#/print_list?status=1&order_id_arr=` + id +
        '&user_token=' + token
      this.$store.dispatch('app/paintStatus', false);
      ipcRenderer.send('print', url, this.printerName, 'A4', 70.0)
      this.recordOrderPrintCount(id)
      setTimeout(() => {
        this.stopShow = false
      }, 2000)
    },
    async recordOrderPrintCount(id) {
      const res = await this.$api.recordOrderPrintCount({order_num: [id]})
    },
    async getOrderList() {
      try {
        this.orderList.setOtherParams({status: 2, show_app: 2});
        await this.orderList.getPageData().catch((e)=>{
          console.log(e)
        });
        this.print()
        this.timerId = setTimeout(() => {
          this.getOrderList()
        }, 10000)
      }catch (e) {
        console.log(e)
      }
    },
    async pageChange(e) {
      await this.orderList.getPageData(e);
    },
    print() {
      for (let i = 0; i < this.orderList.currentPageData.length; i++) {
        let item = this.orderList.currentPageData[i];
        if (item.print_num == 0) {
          clearTimeout(this.timerId);
          this.go(item.id)
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  //background-color: #fff;
  border-radius: 10px;
  margin: 20px;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #3e5a83;
}

.imgList {
  padding: 30px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 150px;
    height: 150px;
    border-radius: 10px;

    img {
      width: 50px;
      height: 50px;
    }

    .itemname {
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #3e5a83;
    }

    .itemDay {
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
      color: #3e5a83;
    }
  }
}

//::v-deep .el-input__inner{
//  border: none !important;
//}


.buttonList {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  margin: 10px 0;
}

.selected {
  background-color: #3553ba;
  border-radius: 10px;
  padding: 20px 30px;
  cursor: pointer;
  color: #ffffff;
}

.noSelect {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px 30px;
  cursor: pointer;
  border: 1px solid #DCDFE6;
}
</style>

